// react
import { useMemo } from 'react';

// components
import { FieldProps, RadioGroup } from '@/components/atoms';

/**
 * Boolean allows the user to select a boolean value.
 */
export const Boolean = ({
  id,
  label,
  description,
  tooltip,
  value,
  onChange,
  isDisabled = false,
  isRequired = false,
  isHideTitle = false,
  ariaLabel,
}: BooleanProps) => {
  const valueString = useMemo(() => {
    if (value === true || (value as unknown as string) === 'true') {
      return 'true';
    }
    if (value === false || (value as unknown as string) === 'false') {
      return 'false';
    }
    return '';
  }, [value]);
  return (
    <RadioGroup
      id={id}
      label={label}
      description={description}
      tooltip={tooltip}
      isRequired={isRequired}
      ariaLabel={ariaLabel}
      isHideTitle={isHideTitle}
      isDisabled={isDisabled}
      maxColumns={2}
      options={[
        { label: 'Yes', value: 'true' },
        { label: 'No', value: 'false' },
      ]}
      value={valueString}
      onChange={(val) => {
        if (val === 'true') {
          onChange?.(true);
        } else if (val === 'false') {
          onChange?.(false);
        } else {
          onChange?.(undefined);
        }

        onChange?.(val === 'true');
      }}
    />
  );
};

interface BooleanProps extends FieldProps<boolean | undefined> {}

Boolean.displayName = 'Boolean';

export default Boolean;
